import * as tslib_1 from "tslib";
import { OnChanges, SimpleChanges } from '@angular/core';
import { FormArray } from '@angular/forms';
import { sentry } from 'sentry';
import { FcMaintenanceTypesOutlinedSelectService } from './services/fc-maintenance-types-outlined-select.service';
var FcMaintenanceTypesOutlinedSelectComponent = /** @class */ (function () {
    function FcMaintenanceTypesOutlinedSelectComponent(fcMaintenanceTypesOutlinedSelectService) {
        this.fcMaintenanceTypesOutlinedSelectService = fcMaintenanceTypesOutlinedSelectService;
        this.maintenanceTypes = [];
        this.findBySegment = false;
        this.showAllOption = false;
    }
    FcMaintenanceTypesOutlinedSelectComponent.prototype.ngOnChanges = function (changes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.findBySegment && changes.segmentId.currentValue !== changes.segmentId.previousValue)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.searchMaintenanceTypes()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    FcMaintenanceTypesOutlinedSelectComponent.prototype.searchMaintenanceTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.control.clear();
                        this.control.disable();
                        this.maintenanceTypes = [];
                        if (!this.segmentId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, 6, 7]);
                        return [4 /*yield*/, this.fcMaintenanceTypesOutlinedSelectService.getMaintenanceTypesBySegmentId(this.segmentId)];
                    case 2:
                        results = _a.sent();
                        this.showAllOption = !results.length;
                        if (!!results.length) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fcMaintenanceTypesOutlinedSelectService.getPaginatedMaintenanceTypes()];
                    case 3:
                        results = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.maintenanceTypes = results.map(function (item) { return ({
                            text: item.name,
                            value: item
                        }); });
                        return [3 /*break*/, 7];
                    case 5:
                        err_1 = _a.sent();
                        sentry.captureException(err_1);
                        return [3 /*break*/, 7];
                    case 6:
                        this.control.enable();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return FcMaintenanceTypesOutlinedSelectComponent;
}());
export { FcMaintenanceTypesOutlinedSelectComponent };
